import React from "react";

import { hydrateRoot } from "react-dom/client";
import { ProductDetailView } from "../components/Products/ProductDetailView";
import { Product } from "../components/Products/types";
import { InventoryContextProvider } from "src/components/Inventory/context";
import { ApiContext } from "src/components/Inventory/context-api";

const container = document.getElementById("pnlReactRoot");

const DEBUG_HYDRATION = true;

if (container) {
  const raw = container.dataset.product!;
  const item: Product = JSON.parse(raw);

  const innerContainer = container.children.item(0);

  if (innerContainer) {
    hydrateRoot(
      innerContainer,
      <InventoryContextProvider value={ApiContext}>
        <ProductDetailView item={item} />
      </InventoryContextProvider>,
      DEBUG_HYDRATION
        ? {
            onRecoverableError(error, errorInfo) {
              console.groupCollapsed(
                "%c🚨 Hydration Mismatch",
                "color: red; font-weight: bold;"
              );
              console.error(error);
              console.log("Error Info:", errorInfo.componentStack);
              console.groupEnd();
            },
          }
        : undefined
    );
  }
}
